export default __webpack_public_path__ + "images/sweep1.ef4f05d35cd5d07980d46555e0c14139.gif";